// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"f174260c","277":"07b7294d"}[chunkId] + ".chunk.css";
};